import React from "react";
export var CheckoutKpay = function () {
    return React.createElement("div", null, "Kpay Here!");
};
